import {  Component, OnInit } from '@angular/core';
import { FrtBillOfLadingService } from './frt-bill-of-lading.service';
import { LoadingService } from '../../services/loading/loading.service';
import { AlertService } from '../../services/alert/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { takeWhile } from 'rxjs';
import { Carrier } from 'src/app/services/carrier/carrier';
import { CarrierService } from '../../services/carrier/carrier.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { BolCorrectionNoticeEntity, FrtBillOfLadingDetails } from 'src/app/shared/common-components/common-structure';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import { BillOfLadingService } from '../../services/bill-of-lading/bill-of-lading.service';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';
import {saveAs} from 'file-saver';

@Component({
    selector: 'app-frt-bill-of-lading',
    templateUrl: './frt-bill-of-lading.component.html',
    styleUrls: ['./frt-bill-of-lading.component.css'],
    standalone: false
})
export class FRTBillOfLadingComponent implements OnInit {
  private observer$ = new BehaviorSubject(true);
  customClass = 'customClass';
  isFirstOpen = true;

  frtBolForm: UntypedFormGroup;
  bolDetailsData: any = {};
  bolInfo: FrtBillOfLadingDetails;
  shipmentDetailsInfo: any = {};
  shipmentCostInfo: any = {};
  shipmentsInfo: any = {};
  bookshipmentInfo: any = {};
  ratesFrtInfo: any = {};
  rateTypesInfo: any = {};
  shipperInfo: any = {};
  agencyInfo: any = {};
  carrierOrganizationInfo: any = {};
  sealNos: any[];
  purchaseOrders: any[];
  carrier: Carrier;
  bookShipmentId: number;
  shipmentInfoIdFromUrl: any;
  totalCost: number;
  shipmentDetailsId: number;
  additionalRemarks: string;

  fromGenerateOrView: string;
  viewFRTBillOfLadingPDF: boolean;
  billOfLadingNbr: string;
  isSaveForPDF: boolean;
  isOneTimeShipment = false;

  constructor(private frtBillOfLadingService: FrtBillOfLadingService, private loader: LoadingService, private router: Router,
    private alertService: AlertService, private route: ActivatedRoute, private carrierService: CarrierService,
    private formBuilder: UntypedFormBuilder, private billOfLadingService: BillOfLadingService,
    private userProfileService: UserProfileService) { }

  ngOnInit() {
    this.shipmentInfoIdFromUrl = this.route.snapshot.queryParams['shipmentId'];
    this.createFrtBolForm();
    this.getBolDetailsByShipmentId(this.shipmentInfoIdFromUrl);

  }

  createFrtBolForm() {
    this.frtBolForm = this.formBuilder.group({
      billOfLadingShipmentFinalization: []
    });
  }
  /**
   * @description To get bol details by shipment info id
   * @param shipmentInfoId: Shipment id of the shipment
   */
  getBolDetailsByShipmentId(shipmentid) {
    this.loader.show();
    this.frtBillOfLadingService.getBolDetailsByShipmentId(shipmentid).
      pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
        this.bolDetailsData = data;
        this.loadInitialData();
        this.alertService.success('Successfully retrieved bol details');
      }, error => {
        this.loader.hide();
        console.log('There was an error retrieving frt bol details by shipment id' + error);
        this.alertService.error('Error retrieving bol details');
      }, () => {
        this.frtBillOfLadingService.updateFrtBolDetailsId(this.bolDetailsData.frtBolDetailsID);
        this.loader.hide();
      });
  }

  /**
   * @description Prepopulates selected data from the previous page
   */
  loadInitialData() {
    this.bolInfo = this.bolDetailsData;
    this.shipmentsInfo = this.bolInfo.shipmentsInfoEntity;
    this.shipmentCostInfo = this.shipmentsInfo.frtShipmentsCostInfoEntity;
    this.bookShipmentId = this.shipmentsInfo.bookShipmentsEntity.bookShipmentId;
    this.shipmentDetailsInfo = this.shipmentsInfo.frtShipmentDetailsEntity;
    this.shipmentDetailsId = this.shipmentDetailsInfo.frtShipmentDetailsId;
    this.sealNos = this.shipmentsInfo.frtShipmentDetailsEntity.frtShipmentSealNosEntity;
    this.purchaseOrders = this.shipmentsInfo.frtShipmentDetailsEntity.frtShipmentPurchaseOrderEntity;
    this.shipperInfo = this.shipmentsInfo.bookShipmentsEntity.userEntity;
    this.loadCarrierDetails(this.shipmentCostInfo.carrierId);
    // this.loadAgencyDetails(this.shipmentsInfo.bookShipmentsEntity.userId);
    const organizationEntity = this.shipmentsInfo.bookShipmentsEntity.organizationEntity;
    if (AppConstants.isNotNullCondition(organizationEntity) && AppConstants.isNotNullCondition(organizationEntity.agencyCustomerEntity)) {
      this.agencyInfo = organizationEntity.agencyCustomerEntity.agencyMasterEntity;
    }
    this.totalCost = this.shipmentCostInfo.totalCost;
    this.additionalRemarks = this.bolInfo.additionalRemarks;
    if (this.shipmentsInfo.bookShipmentsEntity.oneTimeOnly === 1) {
      this.isOneTimeShipment = true;
      this.bookshipmentInfo = this.shipmentsInfo.bookShipmentsEntity;
    }
    const shipmentCostInfo = this.shipmentsInfo.frtShipmentsCostInfoEntity;
    this.ratesFrtInfo = shipmentCostInfo ? shipmentCostInfo.ratesFrtEntity : this.ratesFrtInfo;
    this.rateTypesInfo = this.ratesFrtInfo ? this.ratesFrtInfo.rateTypesEntity : this.rateTypesInfo;
    this.billOfLadingNbr = this.bolInfo.bolNumber;
    console.log('this.billOfLadingNbr : ' + this.billOfLadingNbr);
  }

  /**
  * @description To get carrier details
  */
  loadCarrierDetails(carrierId) {
    if (carrierId) {
      this.loader.show();
      this.carrierService.getCarrierByCarrierId(carrierId).subscribe(data => {
        if (AppConstants.isNotNullCondition(data)) {
          this.carrier = data;
          if (this.carrier.carrierContactInfoEntity.length !== 0 ) {
            for (let i = 0; i < this.carrier.carrierContactInfoEntity.length; i++) {
              if (this.carrier.carrierContactInfoEntity[i].contactType === 'FRT') {
              this.carrierOrganizationInfo = this.carrier.carrierContactInfoEntity[i];
              break;
              } else {
                this.carrierOrganizationInfo = this.carrier.organizationEntity;
              }
            }
          } else {
            this.carrierOrganizationInfo = this.carrier.organizationEntity;
          }
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        console.log('There was an error retrieving TSP details =>' + error);
        this.alertService.error('Error retrieving TSP details');
      });
    }
  }

  /**
       * @description To get agency/bureau details
       */
  loadAgencyDetails(userId) {
    if (userId) {
      this.loader.show();
      this.userProfileService.getUser(userId).subscribe(user => {
        if (AppConstants.isNotNullCondition(user)) {
          this.agencyInfo = user.organizationEntity.agencyCustomerEntity != null ?
            user.organizationEntity.agencyCustomerEntity.agencyMasterEntity : null;
          this.bolDetailsData.organizationId = user.organizationEntity.organizationId;
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        console.log('There was an error retrieving agency details =>' + error);
        this.alertService.error('Error retrieving agency details');
      });
    }
  }

  saveBillOfLadingDetails() {
    let bolDetails = new FrtBillOfLadingDetails();
    const billOfLadingFormValue = this.frtBolForm.getRawValue();
    bolDetails = this.bolInfo;
    if (AppConstants.isNotNullCondition(this.bolInfo.bolNumber)) {
      bolDetails.frtBolCorrectionNoticeEntity = <BolCorrectionNoticeEntity>(billOfLadingFormValue.billOfLadingShipmentFinalization);
    }
    bolDetails.additionalRemarks = this.frtBolForm.value.billOfLadingShipmentFinalization.additionalRemarks;
    this.loader.show();
    this.frtBillOfLadingService.saveBolInfo(bolDetails).subscribe(data => {
      this.loader.hide();
      if (!this.isSaveForPDF) {
        this.alertService.success('Successfully updated bol details');
      }
    }, error => {
      this.loader.hide();
      console.log('Error updating frt bol=', error);
    });
  }

  backToOnlineBooking() {
    this.router.navigate(['/', 'frtbookshipment'], {
      queryParams:
        { bookshipmentid: this.shipmentsInfo.bookShipmentsEntity.bookShipmentId }
    });
  }

  generateBillOfLadingPDF(from?) {
    this.loader.show();
    this.isSaveForPDF = true;
    // this.saveBillOfLadingDetails();
    if (from === 'generateFRT') {
      this.fromGenerateOrView = 'generateFRT';
    } else if (from === 'previewFRT') {
      this.fromGenerateOrView = 'previewFRT';
    }
    // this.viewFRTBillOfLadingPDF = false;

    let bolDetails = new FrtBillOfLadingDetails();
    const billOfLadingFormValue = this.frtBolForm.getRawValue();
    bolDetails = this.bolInfo;
    if (AppConstants.isNotNullCondition(this.bolInfo.bolNumber)) {
      bolDetails.frtBolCorrectionNoticeEntity = <BolCorrectionNoticeEntity>(billOfLadingFormValue.billOfLadingShipmentFinalization);
    }
    bolDetails.additionalRemarks = this.frtBolForm.value.billOfLadingShipmentFinalization.additionalRemarks;
    bolDetails.carrier = this.carrier;

    this.billOfLadingService.getFRTBillOfLadingPDFData(bolDetails, this.fromGenerateOrView)
      .subscribe
      (callResp => {
        if (this.fromGenerateOrView === 'generateFRT') {
          this.router.navigate(['/', 'shipmentcontrolreview'],
            { queryParams: { bookshipmentid: this.bookShipmentId, shipmentType: 'FRT' } });
        }
        this.loader.hide();
        this.alertService.success('Document generated / downloaded successfully');
        this.saveDownloadResponse(callResp);
      }, (error) => {
        this.loader.hide();
        this.alertService.error('Error Downloading Report');
        console.log('== Error => ', error);
      });
  }

  saveDownloadResponse(downloadResponse: any) {
    const byteData: number[] = downloadResponse.byteData;
    const fileName: string = downloadResponse.fileName;
    const numRows: number = downloadResponse.numberOfExcelRows;
    const bytes = new Uint8Array(byteData);
    /*     let blob = new Blob([bytes], {
             type: null
         }); */
    const blob = new Blob([bytes], { type: 'application/pdf' });
    const objectUrl = URL.createObjectURL(blob);
    window.open(objectUrl);
    saveAs(blob, fileName);
  }

  generateFRTCorrectionNoticePDF() {
    this.loader.show();
    console.log(' Is control coming here?  + event.target.value ');
    this.viewFRTBillOfLadingPDF = false;

    let bolDetails = new FrtBillOfLadingDetails();
    const billOfLadingFormValue = this.frtBolForm.getRawValue();
    bolDetails = this.bolInfo;
    bolDetails.frtBolCorrectionNoticeEntity = <BolCorrectionNoticeEntity>(billOfLadingFormValue.billOfLadingShipmentFinalization);
    bolDetails.additionalRemarks = this.frtBolForm.value.billOfLadingShipmentFinalization.additionalRemarks;
    bolDetails.carrier = this.carrier;

    this.billOfLadingService.getFRTCorrectionNoticePDFData(bolDetails)
      .subscribe
      (callResp => {
        this.saveDownloadResponse(callResp);
        this.loader.hide();
        this.alertService.success('Document generated / downloaded successfully');
      }, (error) => {
        this.loader.hide();
        this.alertService.error('Error Downloading Report');
        console.log('== Error => ', error);
      }, () => {
        this.router.navigate(['/', 'shipmentcontrolreview'],
            { queryParams: { bookshipmentid: this.bookShipmentId, shipmentType: 'FRT' } });
      });
  }

}


